import {Directive, ElementRef, Input} from '@angular/core';

/*
 Generated class for the ConviteHover directive.

 See https://angular.io/docs/ts/latest/api/core/index/DirectiveMetadata-class.html
 for more info on Angular 2 Directives.
 */
@Directive({
    selector: '[conviteHover]', // Attribute selector
    host: {
        '(mouseenter)': 'onMouseEnter()',
        '(mouseleave)': 'onMouseLeave()'
    }
})
export class ConviteHoverDirective {

    private _element: HTMLElement;

    constructor(public element:ElementRef) {

        this._element = element.nativeElement;

    }

    @Input() defaultColor: string;
    @Input('conviteHover') highlightColor: string;
    @Input('txtColor') txtColor: string;

    ngOnInit() {


    }

    //@HostListener('mouseenter')
    //noinspection JSUnusedGlobalSymbols
    public onMouseEnter() {
        this.highlight(this.highlightColor, this.defaultColor);
    }

    //@HostListener('mouseleave')
    //noinspection JSUnusedGlobalSymbols
    public onMouseLeave() {
        this.highlight(this.defaultColor, this.txtColor);
    }

    private highlight(color: string, rColor: string) {
        this._element.querySelector('.cvt-bg-color').setAttribute('fill', color);
        let elems = this._element.querySelectorAll('.cvt-txt-color');
        for (let i in elems) {
            if (isNaN(parseFloat(i))) continue;
            elems[i].setAttribute('fill', rColor);
        }
    }

}



// WEBPACK FOOTER //
// ./src/directives/convite-hover.ts